export const getCommercialRelationFromUrl = (path: string): string | null => {
  if (path === '/') return null;
  const root = path.split('/')[1];
  if (root.indexOf('_CR_') > -1) return root;
  return null;
};
